export default "__VITE_ASSET__B0GLn1fV__"